class OrderHistoryController {

    constructor(userService) {
        this.userService = userService;
    }

    $onInit () {
        this.orders = {};
        this.loading = [];

        return this.getOrders();
    }

    getOrders () {
        return Promise.all([
            this.getOrdersByTime('future'),
            this.getOrdersByTime('past')
        ]);
    }

    getOrdersByTime (timeframe, page = 1) {
        if (this.isLoading(timeframe)) {
            return;
        }

        this.loading.push(timeframe);
        this.orders[timeframe] = {};

        return this.userService.orderHistory(timeframe, page)
            .then((response) => {
                this.orders[timeframe] = response;
            })
            .catch(() => { })
            .then(() => {
                this.stopLoading(timeframe);
            });
    }

    stopLoading (timeframe) {
        const index = this.loading.indexOf(timeframe);
        if (index > -1) {
            this.loading.splice(index, 1);
        }
    }

    isLoading (timeframe) {
        return this.loading.indexOf(timeframe) > -1;
    }
}

OrderHistoryController.$inject = ['userService'];

export default OrderHistoryController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/controllers/order.history.controller.js